import{a as c}from"./chunk-22L2SDLD.js";import{a as n}from"./chunk-QN7PNIMD.js";import{m as a}from"./chunk-HBP5N4FR.js";a();function i(r){return c(r),n(r),null}export{i as a};
//# sourceMappingURL=chunk-LWQDE754.js.map
